"use client";
// import BlogDetail from "../../components/BlogDetail";
// import Product from "./san-pham/back-up-[...product]";
// import Policy from "../chinh-sach/[policy]";
// import Product from "../(san-pham)/[...slug]";

import React from "react";
import dynamic from 'next/dynamic'
import LoadingComponent from "../../components/Loading";
import NotFound from "../not-found";
import { loadServerSideProps } from "../../utils/utils";

const DynamicProducts = dynamic(() => import('../../components/ProductList'));
const DynamicTags = dynamic(() => import('../tu-khoa/[...slug]'));
const DynamicBlogs = dynamic(() => import('../../components/BlogList'));
const DynamicBlogDetail = dynamic(() => import('../../components/BlogDetail'));
const DynamicPolicy = dynamic(() => import('../chinh-sach/[policy]'), { ssr: false })
const DynamicProduct = dynamic(() => import('../(san-pham)/[...slug]'));
const DynamicSearch = dynamic(() => import('../search/[...slug]'));

// export function arrayProductData(array: Array<any>) {
//     let cloneArrayTypeProduct: any = array ?? [];
//     for (let index = 0; index < array?.length; index++) {
//         const children = array[index]?.children ?? [];
//         let child = [];
//         if (children.length > 0) {
//             child = arrayProductData(children);
//             cloneArrayTypeProduct = cloneArrayTypeProduct.concat(child);
//         }
//     }
//     return cloneArrayTypeProduct;
// }

// export function getServerSideProps({ req, res }: any) {
//     res.setHeader(
//         'Cache-Control',
//         'public, s-maxage=10, stale-while-revalidate=59'
//     )
//     return {
//         props: {

//         },
//     };
// }

import { useRouter } from "next/router";
// { params, data, type }: any
const DynamicRoute = ({ seo, products }:any) => {
    if(seo?.type > -1)
        return <Render seo={seo} products={products}/>
    return <></>
}

export const getServerSideProps = (async (context:any) => {
    const { slug } = context.params as { slug: Array<string> }; // Access the slug from context.params
    if (slug) {
      try {
        let url = slug?.join("/");
        if(!url.includes(".json") && !url.includes(".js")){
            let temp:any = await loadServerSideProps(url, context.query);
            if (temp.seo.type < -1) {
                return {redirect: {
                            destination: '/'
                        }};
            }
            else if (temp.seo.check_url && !temp.seo.check_url.is_main) {
                return {redirect: {
                            destination: temp.seo.check_url.url
                        }};
            }
            else {
                return { props: temp }
            }
        }
      } catch (error) { 
        console.log("error: ",error);
        return {props: {}};
      }
    }
    return {props: {}};
});

// export const getStaticProps = async (
//     context:any
//   ) => {
//     const slug = context?.params?.slug;
//     if (slug) {
//       try {
//         let url = (slug as Array<string>)?.join("/");
//         if(!url.includes(".json") && !url.includes(".js")){
//             let temp:any = await loadServerSideProps(url);
//             if (temp.seo.type < -1) {
//                 return {redirect: {
//                             destination: '/'
//                         }};
//             } else {
//                 return { props: temp, revalidate: 60 }
//             }
//         }
//       } catch (error) { 
//         console.log("error: ",error);
//         return {props: {}};
//       }
//     }
//     return {props: {}};
//   };

// export async function getStaticPaths() {
//     return {
//         paths: [], //indicates that no page needs be created at build time
//         fallback: 'blocking' //indicates the type of fallback
//     }
// }

const Render = ({ seo, products }: any) => {
    const router = useRouter();
    let url = router.query.slug ? "/" + (router.query.slug as Array<string>)?.join("/") : "";
    if (url === "/chinh-sach/quy-dinh-thue") {
        return <DynamicPolicy />
    } else if (url === "/chinh-sach/goi-thue") {
        return <DynamicPolicy />
    } else if (url.indexOf("/tu-khoa") > -1) {
        return <DynamicTags />
    }
    else if (url.includes("/search")) {
        return <DynamicSearch />
    }
    switch (seo.type) {
        case 0:
            return <DynamicProducts
                    groupTypeProductsData={[]}
                    key={"product"}
                    branchDatas={[]}
                    typeProductsData={[]}
                    filterSetData={[]}
                    productGroupsData={[]}
                    productsData={products}
                    activeTypeData={""} 
                    seo={seo}/>
        case 1:
            return <DynamicProduct seo={seo}/>
            break;
        case 2:
            return <DynamicBlogs seo={seo}/>
        case 3:
            return <DynamicBlogDetail seo={seo}/>
        case 4:
            return <DynamicPolicy />
            break;
        case 5:
            return <DynamicPolicy />
            break;
        case 6:
            return <DynamicTags />
            break;
        case -1:
            return <LoadingComponent loading={true} />
            break;
        default:
            return <NotFound />
            // return <LoadingComponent loading={true} />
            break;
    }

}

export default DynamicRoute;